import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { db } from "@/lib/db-client";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { audit } from "@/lib/audit-client";

export const Route = createFileRoute("/_authenticated/admin/materials")({
  component: MaterialsAdmin,
});

function MaterialsAdmin() {
  const [rows, setRows] = useState<any[]>([]);
  const [name, setName] = useState("");

  const load = () => db.from("materials").select("*").order("name").then(({ data }) => setRows(data ?? []));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name) return;
    const { data, error } = await db.from("materials").insert({ name }).select().single();
    if (error) return toast.error(error.message);
    await audit("material.create", { entity: "materials", entity_id: data?.id, metadata: { name } });
    setName(""); load();
  };
  const update = async (id: string, patch: any) => {
    const { error } = await db.from("materials").update(patch).eq("id", id);
    if (error) return toast.error(error.message);
    await audit("material.update", { entity: "materials", entity_id: id, metadata: { changes: patch } });
    load();
  };
  const remove = async (id: string) => {
    if (!confirm("Supprimer cette matière ?")) return;
    const { error } = await db.from("materials").delete().eq("id", id);
    if (error) return toast.error(error.message);
    await audit("material.delete", { entity: "materials", entity_id: id });
    load();
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Matières</h1>
      <Card><CardContent className="p-4 flex gap-2">
        <Input placeholder="Nom de la matière" value={name} onChange={(e) => setName(e.target.value)} />
        <Button onClick={add}><Plus className="h-4 w-4 mr-1" /> Ajouter</Button>
      </CardContent></Card>
      <Card><CardContent className="p-0">
        <Table>
          <TableHeader><TableRow><TableHead>Nom</TableHead><TableHead>Active</TableHead><TableHead /></TableRow></TableHeader>
          <TableBody>
            {rows.map(r => (
              <TableRow key={r.id}>
                <TableCell>
                  <Input defaultValue={r.name} onBlur={(e) => e.target.value !== r.name && update(r.id, { name: e.target.value })} />
                </TableCell>
                <TableCell><Switch checked={r.active} onCheckedChange={(v) => update(r.id, { active: v })} /></TableCell>
                <TableCell><Button variant="ghost" size="icon" onClick={() => remove(r.id)}><Trash2 className="h-4 w-4" /></Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
